import React, { useEffect, useState } from 'react'
import { SubHeader } from '../../../utils/componentes-utiles/SubHeader';
import { CircularProgress } from '@mui/material';
import { getJornadas } from '../../../services/apis';

export const Jornadas = () => {

    const [jornadas, setJornadas] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [ocpionesJornada, setOpcionesJornada] = useState([]);

    const cargarJornadas = async () => {
        try {
            const response = await getJornadas();
            if (response.success) {
                setJornadas(response.data);
                setLoaded(true);
            } else {
                console.error('Error al cargar las jornadas:', response.message);
            }
        }
        catch (error) {
            console.error('Error al cargar las jornadas:', error);
        }
    }

    useEffect(() => {
        cargarJornadas();
    }, []);

    return (
        <div className='fade-in-2 '>
            <SubHeader />
            {!loaded && (
                <CircularProgress size={40} />
            )}
            {(loaded && jornadas.length > 0 && ocpionesJornada) && (
                <>

                </>
            )
            }
        </div >
    )
}

